module.exports = __webpack_public_path__ + "img/Bank BJB Syariah.615e68de.png";